import React from 'react';
import { Mui } from '@osu/react-ui';

/**
 * SearchStatus Component
 * Displays loading indicators and error messages
 */
function SearchStatus({
  showLoadingIndicator,
  searchError,
  isSearching
}) {
  // Don't render anything if no status to show
  if (!showLoadingIndicator && !searchError) {
    return null;
  }

  return (
    <Mui.Box sx={{ mb: 2 }}>
      {/* Loading Indicator */}
      {showLoadingIndicator && (
        <Mui.Alert
          severity="info"
          icon={<Mui.CircularProgress size={20} />}
          sx={{
            backgroundColor: '#e3f2fd',
            border: '1px solid #2196f3',
            '& .MuiAlert-icon': {
              alignItems: 'center'
            }
          }}
        >
          <Mui.Typography variant="body2" sx={{ fontWeight: 500 }}>
            Searching students...
          </Mui.Typography>
        </Mui.Alert>
      )}

      {/* Search Error */}
      {searchError && !showLoadingIndicator && (
        <Mui.Alert severity="error">
          {searchError}
        </Mui.Alert>
      )}
    </Mui.Box>
  );
}

export default SearchStatus;